/**
 * LA ROUTE DE LA SCÈNE D'APPEL — une seule constante, lue par tout ce qui y
 * MÈNE depuis l'extérieur (overlay d'entrant, barre d'appel, pastille).
 *
 * Issue #220 : la scène (`pages/SoftphoneV2Page.tsx`) est le seul écran qui
 * sache rendre un appel en cours et sa qualification ; elle lit la machine
 * globale, donc y arriver avec un appel déjà engagé suffit — rien n'est à
 * relancer. Les surfaces globales n'ont qu'à savoir où elle vit, et si l'on y
 * est déjà (pour ne pas naviguer vers soi-même, ni se superposer à elle).
 */
export const SCENE_ROUTE = '/v2/softphone'

/** Vrai si `pathname` EST la scène d'appel (fin de slash tolérée). */
export function isSceneRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  const trimmed = pathname.replace(/\/+$/, '')
  return trimmed === SCENE_ROUTE
}
